import { useState, useEffect } from "react";
import axios from "../axios";

export type SearchResult = {
    id: number;
    title: string;
    posterUrl?: string | null;
    backdropUrl?: string | null;
    year?: string | null;
    adult: boolean;
    type: "movie" | "show" | "person";
    genres?: string[];
};

export const useDebouncedSearch = (query: string, delay = 400) => {
    const [results, setResults] = useState<SearchResult[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!query.trim()) {
            setResults([]);
            return;
        }

        const timeout = setTimeout(async () => {
            try {
                setLoading(true);

                const res = await axios.get("/search", {
                    params: { query, page: 1 },
                });

                setResults(res.data.results || []);
            } catch {
                setResults([]);
            } finally {
                setLoading(false);
            }
        }, delay);

        return () => clearTimeout(timeout);
    }, [query, delay]);

    return { results, loading };
};
